import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CreateSupplierDto } from '../../dtos/create-supplier.dto';
import { UpdateSupplierDto } from '../../dtos/update-supplier.dto';
import { createSupplierSchema } from '../schemas/create-supplier.schema';
import { updateSupplierSchema } from '../schemas/update-supplier.schema';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
	record: CreateSupplierDto | UpdateSupplierDto,

	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check
	if (!record) throw new Error('record is required.');

	let validationResult: ValidationResult | undefined;

	// TODO: Revise this check once front-end is able to use different
	// DTOs for create and update

	// Check if record has an id property with a value to determine if
	// it's an update or create operation
	if ('id' in record && record.id) {
		validationResult = updateSupplierSchema().validate(record, {
			abortEarly,
		});
	} else {
		validationResult = createSupplierSchema().validate(record, {
			abortEarly,
		});
	}

	// Check for validation errors
	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	// Return
	return { isValid: true };
};
